module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('app-modal', {
    staticClass: "c-modal-play"
  }, [_c('div', {
    staticClass: "c-modal-play__bg u-absolute u-pos-tl u-fit",
    on: {
      "click": _vm._close
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "c-modal-play__box u-relative u-pad-y-1 u-marg-y-xxl u-marg-y-lg@md"
  }, [_c('div', {
    staticClass: "c-modal-play__box-bg u-absolute u-pos-tl u-fit"
  }), _vm._v(" "), (_vm.state === 'error') ? _c('div', {
    staticClass: "c-modal-play__box-content u-relative"
  }, [_c('h2', {
    staticClass: "c-modal-play__title t-h u-uppercase u-bold u-marg-b-xs",
    domProps: {
      "innerHTML": _vm._s(_vm.contentGlobal.popinPlaying.error.title)
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "t-lspacing--sm t-text--sm u-line-height--md u-marg-b-xs u-marg-b-xl u-opacity--5 u-w8of9 u-fit@md",
    domProps: {
      "innerHTML": _vm._s(_vm.contentGlobal.popinPlaying.error.description)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "u-flex--x u-block@lg u-align-center@lg"
  }, [_c('app-btn', {
    staticClass: "c-btn--secondary u-align-center u-inline-block@lg u-marg-b-xs@lg",
    attrs: {
      "to": _vm.$root.getPageURLFromID('watchNow')
    }
  }, [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.contentGlobal.popinPlaying.error.btnWatch)
    }
  })]), _vm._v(" "), (_vm.contentGlobal.mainMenu.buy) ? [_c('div', {
    staticClass: "u-flex__item--auto"
  }), _vm._v(" "), _c('app-btn', {
    staticClass: "c-btn--secondary u-align-center u-inline-block@lg u-marg-b-xs@lg",
    attrs: {
      "to": _vm.contentGlobal.mainMenu.buy.href,
      "target": "_blank",
      "rel": "nofollow noopener noreferrer"
    },
    on: {
      "click": function($event) {
        _vm.pushBuyToGTM(_vm.contentGlobal.mainMenu.buy.href)
      }
    }
  }, [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.contentGlobal.mainMenu.buy.label)
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "u-flex__item--auto"
  })] : _c('div', {
    staticClass: "u-marg-l-xs"
  }), _vm._v(" "), _c('app-btn', {
    staticClass: "c-btn--secondary u-align-center u-inline-block@lg",
    attrs: {
      "to": _vm.$root.getPageURLFromID('news')
    }
  }, [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.contentGlobal.popinPlaying.error.btnUpdate)
    }
  })])], 2)]) : _vm._e(), _vm._v(" "), (_vm.state === 'success1') ? _c('div', {
    staticClass: "c-modal-play__box-content u-relative"
  }, [_c('h2', {
    staticClass: "c-modal-play__title t-h u-uppercase u-bold u-marg-b-xs",
    domProps: {
      "innerHTML": _vm._s(_vm.contentGlobal.popinPlaying.success1.title)
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "t-lspacing--sm t-text--sm u-line-height--md u-marg-b-xs u-marg-b-xl u-opacity--5 u-w8of9 u-fit@md",
    domProps: {
      "innerHTML": _vm._s(_vm.contentGlobal.popinPlaying.success1.description)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "u-flex--x u-flex--center u-block@lg u-align-center@lg"
  }, [_c('app-btn', {
    staticClass: "c-btn--secondary u-align-center u-inline-block@lg u-marg-b-xs@lg",
    attrs: {
      "to": _vm.$root.getPageURLFromID('watchNow')
    }
  }, [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.contentGlobal.popinPlaying.success1.btnWatch)
    }
  })]), _vm._v(" "), (_vm.contentGlobal.mainMenu.buy) ? [_c('div', {
    staticClass: "u-flex__item--auto"
  }), _vm._v(" "), _c('app-btn', {
    staticClass: "c-btn--secondary u-align-center u-inline-block@lg u-marg-b-xs@lg",
    attrs: {
      "to": _vm.contentGlobal.mainMenu.buy.href,
      "target": "_blank",
      "rel": "nofollow noopener noreferrer"
    },
    on: {
      "click": function($event) {
        _vm.pushBuyToGTM(_vm.contentGlobal.mainMenu.buy.href)
      }
    }
  }, [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.contentGlobal.mainMenu.buy.label)
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "u-flex__item--auto"
  })] : _c('div', {
    staticClass: "u-marg-l-xs"
  }), _vm._v(" "), _c('app-btn', {
    staticClass: "c-btn--secondary u-align-center u-inline-block@lg",
    attrs: {
      "to": _vm.$root.getPageURLFromID('news')
    }
  }, [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.contentGlobal.popinPlaying.success1.btnUpdate)
    }
  })])], 2)]) : _vm._e(), _vm._v(" "), (_vm.state === 'success2') ? _c('div', {
    staticClass: "c-modal-play__box-content u-relative"
  }, [_c('h2', {
    staticClass: "c-modal-play__title t-h u-uppercase u-bold u-marg-b-xs",
    domProps: {
      "innerHTML": _vm._s(_vm.contentGlobal.popinPlaying.success2.title)
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "t-lspacing--sm t-text--sm u-line-height--md u-marg-b-xs u-marg-b-xl u-opacity--5 u-w8of9 u-fit@md",
    domProps: {
      "innerHTML": _vm._s(_vm.contentGlobal.popinPlaying.success2.description)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "u-flex--x u-block@lg u-align-center@lg"
  }, [_c('app-btn', {
    staticClass: "c-btn--secondary u-align-center u-inline-block@lg u-marg-b-xs@lg",
    attrs: {
      "to": _vm.$root.getPageURLFromID('watchNow')
    }
  }, [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.contentGlobal.popinPlaying.success2.btnWatch)
    }
  })]), _vm._v(" "), (_vm.contentGlobal.mainMenu.buy) ? [_c('div', {
    staticClass: "u-flex__item--auto"
  }), _vm._v(" "), _c('app-btn', {
    staticClass: "c-btn--secondary u-align-center u-inline-block@lg u-marg-b-xs@lg",
    attrs: {
      "to": _vm.contentGlobal.mainMenu.buy.href,
      "target": "_blank",
      "rel": "nofollow noopener noreferrer"
    },
    on: {
      "click": function($event) {
        _vm.pushBuyToGTM(_vm.contentGlobal.mainMenu.buy.href)
      }
    }
  }, [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.contentGlobal.mainMenu.buy.label)
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "u-flex__item--auto"
  })] : _c('div', {
    staticClass: "u-marg-l-xs"
  }), _vm._v(" "), _c('app-btn', {
    staticClass: "c-btn--secondary u-align-center u-inline-block@lg",
    attrs: {
      "to": _vm.$root.getPageURLFromID('news')
    }
  }, [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.contentGlobal.popinPlaying.success2.btnUpdate)
    }
  })])], 2)]) : _vm._e(), _vm._v(" "), (_vm.state === 'success3') ? _c('div', {
    staticClass: "c-modal-play__box-content u-relative"
  }, [_c('h2', {
    staticClass: "c-modal-play__title t-h u-uppercase u-bold u-marg-b-xs",
    domProps: {
      "innerHTML": _vm._s(_vm.contentGlobal.popinPlaying.success3.title)
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "t-lspacing--sm t-text--sm u-line-height--md u-marg-b-xs u-marg-b-xl u-opacity--5 u-w8of9 u-fit@md",
    domProps: {
      "innerHTML": _vm._s(_vm.contentGlobal.popinPlaying.success3.description)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "u-flex--x u-block@lg u-align-center@lg"
  }, [_c('app-btn', {
    staticClass: "c-btn--secondary u-align-center u-inline-block@lg u-marg-b-xs@lg",
    attrs: {
      "to": "https://challenger.gfinityesports.com/",
      "target": "_blank",
      "rel": "nofollow noopener noreferrer"
    }
  }, [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.contentGlobal.popinPlaying.success3.btnChallenger)
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "u-flex__item--auto"
  })], 1)]) : _vm._e(), _vm._v(" "), (_vm.state === 'success4') ? _c('div', {
    staticClass: "c-modal-play__box-content u-relative"
  }, [_c('h2', {
    staticClass: "c-modal-play__title t-h u-uppercase u-bold u-marg-b-xs",
    domProps: {
      "innerHTML": _vm._s(_vm.contentGlobal.popinPlaying.success4.title)
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "t-lspacing--sm t-text--sm u-line-height--md u-marg-b-xs u-marg-b-xl u-opacity--5 u-w8of9 u-fit@md",
    domProps: {
      "innerHTML": _vm._s(_vm.contentGlobal.popinPlaying.success4.description)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "u-flex--x u-block@lg u-align-center@lg"
  }, [_c('app-btn', {
    staticClass: "c-btn--secondary u-align-center u-inline-block@lg u-marg-b-xs@lg",
    attrs: {
      "to": "https://challenger.gfinityesports.com/",
      "target": "_blank",
      "rel": "nofollow noopener noreferrer"
    }
  }, [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.contentGlobal.popinPlaying.success4.btnChallenger)
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "u-flex__item--auto"
  })], 1)]) : (_vm.state === 'check') ? _c('div', {
    staticClass: "c-modal-play__box-content u-relative"
  }, [_c('h2', {
    staticClass: "c-modal-play__title t-h u-uppercase u-bold u-marg-b-xs u-w2of3@xxl",
    domProps: {
      "innerHTML": _vm._s(_vm.contentGlobal.popinPlaying.custom[_vm.typeSlug].title)
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "t-lspacing--sm t-text--sm u-line-height--md u-marg-b-xl u-opacity--5 u-w8of9 u-fit@md u-w2of3@xxl",
    domProps: {
      "innerHTML": _vm._s(_vm.contentGlobal.popinPlaying.custom[_vm.typeSlug].description)
    }
  }), _vm._v(" "), _c('form', {
    staticClass: "u-flex--x u-flex--align-items--center@lg u-flex--y@lg u-w2of3@xxl",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm._check()
      }
    }
  }, [_c('div', {
    staticClass: "u-inline-block u-marg-b-lg u-valign-top u-flex__item--auto u-fit-w"
  }, [_c('input', {
    staticClass: "t-input t-input--text t-text--sm u-fit-w u-marg-r-sm u-marg-b-xxs t-lspacing--md u-color--white",
    attrs: {
      "type": "email",
      "name": "email",
      "placeholder": _vm.contentGlobal.popinPlaying.form.email.toUpperCase()
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "t-text--xxs u-bold u-color--red-pure u-uppercase t-lspacing--md u-marg-l-xxs u-opacity--6",
    domProps: {
      "innerHTML": _vm._s(_vm.errors.email)
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "u-inline-block u-valign-top u-marg-l-xl u-marg-l-0@lg"
  }, [_c('app-btn', {
    staticClass: "c-btn--secondary u-block u-align-center u-inline-block@lg",
    on: {
      "click": function($event) {
        _vm._check()
      }
    }
  }, [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.contentGlobal.popinPlaying.custom[_vm.typeSlug].submit)
    }
  })])], 1)])]) : (_vm.state === 'form') ? _c('div', {
    staticClass: "c-modal-play__box-content u-relative"
  }, [_c('h2', {
    staticClass: "c-modal-play__title t-h u-uppercase u-bold u-marg-b-xs",
    domProps: {
      "innerHTML": _vm._s(_vm.contentGlobal.popinPlaying.form.title)
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "t-lspacing--sm t-text--sm u-line-height--md u-marg-b-xl u-opacity--5 u-w8of9 u-fit@md",
    domProps: {
      "innerHTML": _vm._s(_vm.contentGlobal.popinPlaying.form.description)
    }
  }), _vm._v(" "), _c('router-link', {
    staticClass: "u-color--red-pure u-uppercase t-text--sm u-marg-b-xl u-block u-bold t-lspacing--sm",
    attrs: {
      "to": _vm.$root.getPageURLFromID('esAbout')
    }
  }, [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.contentGlobal.popinPlaying.form.more)
    }
  })]), _vm._v(" "), _c('form', {
    staticClass: "u-block u-fit-w u-vacuum",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm._send()
      }
    }
  }, [_c('div', {
    staticClass: "u-inline-block u-w3of7 u-valign-top u-fit-w@lg"
  }, [_c('div', {
    staticClass: "u-marg-b-lg"
  }, [_c('input', {
    staticClass: "t-input t-input--text t-text--sm u-fit-w u-marg-r-sm u-marg-b-xxs t-lspacing--md u-color--white",
    attrs: {
      "type": "text",
      "name": "username",
      "placeholder": _vm.contentGlobal.popinPlaying.form.username.toUpperCase()
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "t-text--xxs u-bold u-color--red-pure u-uppercase t-lspacing--md u-marg-l-xxs u-opacity--6",
    domProps: {
      "innerHTML": _vm._s(_vm.errors.username)
    }
  })]), _vm._v(" "), _c('div', [_c('div', {
    key: "only-captcha",
    staticClass: "is-captcha u-marg-b-xxs"
  }), _vm._v(" "), _c('p', {
    staticClass: "t-text--xxs u-bold u-color--red-pure u-uppercase t-lspacing--md u-marg-l-xxs u-opacity--6 u-marg-b-lg",
    domProps: {
      "innerHTML": _vm._s(_vm.errors.captcha)
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "u-inline-block u-marg-l-w1of7 u-w3of7 u-marg-b-sm u-valign-top u-fit-w@lg u-marg-l-0@lg"
  }, [_c('div', {
    staticClass: "u-relative u-marg-b-md"
  }, [_c('span', {
    staticClass: "t-input t-input--text t-text--sm u-inline-block u-fit-w u-marg-r-sm u-marg-b-xxs t-lspacing--md u-color--white"
  }, [_vm._v(_vm._s(_vm.contentGlobal.popinPlaying.form.nationalities[_vm.nationality] ? _vm.contentGlobal.popinPlaying.form.nationalities[_vm.nationality].toUpperCase() : _vm.contentGlobal.popinPlaying.form.nationality.toUpperCase()))]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.nationality),
      expression: "nationality"
    }],
    staticClass: "u-block u-absolute u-pos-tl u-fit u-opacity--0",
    attrs: {
      "required": "required",
      "name": "nationality"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.nationality = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "disabled": ""
    }
  }, [_vm._v(_vm._s(_vm.contentGlobal.popinPlaying.form.nationality.toUpperCase()))]), _vm._v(" "), _vm._l((_vm.contentGlobal.popinPlaying.form.nationalities), function(_nationality, _key) {
    return _c('option', {
      domProps: {
        "value": _key
      }
    }, [_vm._v(_vm._s(_nationality.toUpperCase()))])
  })], 2), _vm._v(" "), _c('p', {
    staticClass: "t-text--xxs u-bold u-color--red-pure u-uppercase t-lspacing--md u-marg-l-xxs u-opacity--6",
    domProps: {
      "innerHTML": _vm._s(_vm.errors.nationality)
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "u-marg-b-md"
  }, [_c('input', {
    staticClass: "t-input t-input--text t-text--sm u-fit-w u-marg-r-sm u-marg-b-xxs t-lspacing--md u-uppercase u-color--white",
    attrs: {
      "type": "password",
      "name": "password",
      "placeholder": _vm.contentGlobal.popinPlaying.form.password
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "t-text--xxs u-bold u-color--red-pure u-uppercase t-lspacing--md u-marg-l-xxs u-opacity--6",
    domProps: {
      "innerHTML": _vm._s(_vm.errors.password)
    }
  })]), _vm._v(" "), _c('div', [_c('input', {
    staticClass: "t-input t-input--text t-text--sm u-fit-w u-marg-r-sm u-marg-b-xxs t-lspacing--md u-uppercase u-color--white",
    attrs: {
      "type": "password",
      "name": "confirm",
      "placeholder": _vm.contentGlobal.popinPlaying.form.confirm
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "t-text--xxs u-bold u-color--red-pure u-uppercase t-lspacing--md u-marg-l-xxs u-opacity--6",
    domProps: {
      "innerHTML": _vm._s(_vm.errors.confirm)
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "u-inline-block u-w3of7 u-valign-top u-fit-w@lg u-align-center@lg"
  }, [_c('div', {
    staticClass: "u-flex--x u-marg-b-xxs"
  }, [_c('div', {
    staticClass: "u-marg-r-xs",
    on: {
      "click": function($event) {
        _vm.terms = !_vm.terms
      }
    }
  }, [_c('app-btn-radio', {
    staticClass: "is-red is-small",
    attrs: {
      "selected": _vm.terms
    }
  })], 1), _vm._v(" "), _c('p', {
    staticClass: "c-link--terms t-text--xxs u-uppercase t-lspacing--sm u-line-height--md u-align-left u-flex__item--center@lg",
    domProps: {
      "innerHTML": _vm._s(_vm.contentGlobal.popinPlaying.form.terms)
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "t-text--xxs u-bold u-color--red-pure u-uppercase t-lspacing--md u-marg-l-xxs u-opacity--6 u-align-left  u-marg-b-xs",
    domProps: {
      "innerHTML": _vm._s(_vm.errors.terms)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "u-flex--x u-marg-b-xxs"
  }, [_c('div', {
    staticClass: "u-marg-r-xs",
    on: {
      "click": function($event) {
        _vm.newsletter = !_vm.newsletter
      }
    }
  }, [_c('app-btn-radio', {
    staticClass: "is-red is-small",
    attrs: {
      "selected": _vm.newsletter
    }
  })], 1), _vm._v(" "), _c('p', {
    staticClass: "c-link--newsletter t-text--xxs u-uppercase t-lspacing--sm u-line-height--md u-align-left u-flex__item--center@lg",
    domProps: {
      "innerHTML": _vm._s(_vm.contentGlobal.popinPlaying.form.newsletter)
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "t-text--xxs u-bold u-color--red-pure u-uppercase t-lspacing--md u-marg-l-xxs u-opacity--6 u-align-left u-marg-b-lg",
    domProps: {
      "innerHTML": _vm._s(_vm.errors.newsletter)
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "u-inline-block u-marg-l-w1of7 u-w3of7 u-valign-bottom u-fit-w@lg u-marg-l-0@lg u-align-center@lg"
  }, [_c('app-btn', {
    staticClass: "c-btn--secondary u-block u-align-center u-marg-b-lg u-inline-block@lg",
    on: {
      "click": function($event) {
        _vm._send()
      }
    }
  }, [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.contentGlobal.popinPlaying.form.submit)
    }
  })])], 1)])], 1) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "t-btn u-absolute u-pos-tr u-marg-t-md u-marg-r-md u-marg-t-xs@md u-marg-r-xs@md",
    on: {
      "click": _vm._close
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../../assets/modal/icon-btn-close.png"),
      "alt": "Close"
    }
  })])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-8ae80930"}!./src/scripts/components/app-modal-register/template.html
// module id = 939
// module chunks = 0